import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {FormControl} from '@angular/forms';
import {debounceTime, distinctUntilChanged} from 'rxjs';

@Component({
    selector: 'app-auto-search-dropdown',
    templateUrl: './auto-search-dropdown.component.html',
    styleUrl: './auto-search-dropdown.component.scss',
    standalone: false
})
export class AutoSearchDropdownComponent implements OnInit, OnChanges {
  @Input() listData                  : any[];
  @Input() placeholder               : string;
  @Output() selectedValues           = new EventEmitter();
  @Output() searchText               = new EventEmitter();
  @Output() loadMore                 = new EventEmitter();
  @Output() blur                     = new EventEmitter();
  @Input() previousSeletedValues     : any;
  @Input() showEmailIcon             : boolean = false;
  @Input() isMultiSelect             : boolean = true;
  @Input() borderColor               : boolean = false;
  @Input() isDisabled                : boolean = false;
  @Input() showClearIcon             : boolean = false;
  @Input() autoOpen                  : boolean = false;
  @Input() submenuList               : any[] = [];
  showDropDown                       : boolean = false;
  checkedList                        : any[] = [];
  selectedIDs                        : any[] = [];
  multiSelectedIDs                   : any[] = [];
  checkedMultiList                   : any[] = [];
  multiListData                      : any[] = [];
  searchControl                      : FormControl;
  focusedIndex                       : number = -1;
  isLoadingMore                      : any;
  isLoadingPrevious                  : any;
  private shouldFocusInput = false;
  private submenuHoverTimeout: any;
  @ViewChild('dropdownInput') dropdownInput!: ElementRef;
  @ViewChild('dropdownContainer', { static: false }) dropdownContainer: ElementRef;
  dropdownFocusTimeout: any;
  hoveredItem: any = null;
  selectedSubItems: any = {};
  hoveredIndex: number = -1;


  constructor() {
    this.searchControl = new FormControl('');
  }

  ngOnInit(): void {
    if (this.autoOpen) {
      this.showDropdown();
    }
    this.searchControl?.valueChanges.pipe(debounceTime(1000))
    .pipe(distinctUntilChanged()).subscribe((res: any) => {
       this.searchText.emit(this.searchControl.value);
    })
  }

  ngAfterViewChecked() {
    if (this.shouldFocusInput && this.dropdownInput) {
      this.dropdownInput.nativeElement.focus();
      this.shouldFocusInput = false; 
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.multiListData = this.listData;
    if (this.multiSelectedIDs.length > 0 && changes['listData']) {
      this.listData = this.listData?.map((item: any) => {
        if (this.multiSelectedIDs.includes(item._id)) {
          if (!this.checkedMultiList.includes(item.name)) {
            this.checkedMultiList.push(item.name);
          }
          return { ...item, checked: true };
        } else {
          return { ...item, checked: false };
        }
      });
      this.multiListData = this.listData;
    } else if (this.selectedIDs.length > 0 && changes['listData']) {
      this.listData = this.listData?.map((item: any) => {
        if (this.selectedIDs.includes(item._id)) {
          return { ...item, checked: true };
        } else {
          return { ...item, checked: false };
        }
      });
      this.multiListData = this.listData;
    }
    if (changes['previousSeletedValues']) {
      if (this.isMultiSelect) {
        this.multiSelectedIDs = changes['previousSeletedValues']?.currentValue || [];
        this.checkedMultiList = [];
        this.listData = this.listData?.map((item: any) => {
          if (this.multiSelectedIDs?.includes(item._id)) {
            item = { ...item, checked: true };
            this.checkedMultiList.push(item.name);
          } else {
            item = { ...item, checked: false };
          }
          return item;
        });
      } else {
        this.selectedIDs = changes['previousSeletedValues']?.currentValue ? [changes['previousSeletedValues'].currentValue] : [];
        this.checkedList = [];

        this.listData = this.listData?.map((item: any) => {
          if (this.selectedIDs.includes(item._id)) {
            item = { ...item, checked: true };
            this.checkedList = [item.name];
          } else {
            item = { ...item, checked: false };
          }
          return item;
        });
      }
    }
    this.getPreviousSelectedValue();
  }

  getMultiSelectedValue(status: boolean, value: any, isSubItem: boolean = false, parentItem: any = null) {
    const id = isSubItem ? value.name : value._id;
    const name = value.name;
    const idIndex = this.multiSelectedIDs.indexOf(id);
    const nameIndex = this.checkedMultiList.indexOf(name);
    if (status) {
      if (idIndex === -1) {
        this.multiSelectedIDs.push(id);
      }
      if (nameIndex === -1) {
        this.checkedMultiList.push(name);
      }
    } else {
      if (idIndex > -1) {
        this.multiSelectedIDs.splice(idIndex, 1);
      }
      if (nameIndex > -1) {
        this.checkedMultiList.splice(nameIndex, 1);
      }
    }
    if (!isSubItem) {
      this.multiselectedList(status, value._id);
    }
    this.selectedValues.emit(this.multiSelectedIDs);
  }

  singleSelectedValue(value: any) {
    this.previousSeletedValues = value.name;
    this.selectedIDs = [value._id];
    this.checkedList = [value.name];
    this.singleSelectedList(value._id);
    this.selectedValues.emit(value);
    this.showDropDown = false;
  }

  singleSelectedList(id: any) {
    this.listData = this.listData?.map(x => {
      if (x._id === id) {
        return { ...x, checked: true };
      } else {
        return { ...x, checked: false };
      }
    });
  }

  multiselectedList(status: boolean, id: any) {
    this.listData = this.listData?.map(x => {
      if (x._id === id) {
        return { ...x, checked: status };
      }
      return x;
    });
  }

  handleFilter(event: any) {
    this.multiListData = this.listData.filter((s: any) => s.name.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1);
  }

  showDropdown() {
    this.multiListData = this.listData;
    this.showDropDown = !this.showDropDown;
    if (this.showDropDown) {
      this.getPreviousSelectedValue();
    }
    this.shouldFocusInput = true;
    if (this.showDropDown) {
      this.searchControl.setValue('');
      this.multiListData = this.listData;
      this.focusedIndex = -1;
    }
  }

  addItem(newEmail: any) {
    if (newEmail) {
      this.showEmailIcon = true;
      const newItem = { _id: newEmail, name: newEmail, checked: true };
      this.listData.push(newItem);
      this.multiSelectedIDs.push({emailAddress: newEmail});
      this.checkedMultiList.push(newEmail);
      this.selectedValues.emit(this.multiSelectedIDs);
      this.showEmailIcon = false;
      this.listData = [...this.listData];
      this.searchControl.setValue('');
      this.multiListData = this.listData;
      this.searchControl.reset();
    }
  }

  onDropdownScroll(event: any) {
    if (this.searchControl.value?.trim()) return;
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    const clientHeight = event.target.clientHeight;
    if (scrollHeight - scrollTop <= clientHeight + 5) {
      this.loadMore.emit();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (!this.multiListData || this.multiListData.length === 0) return;
    const isFiltered = this.searchControl.value?.trim().length > 0;
    if (event.key === 'ArrowDown') {
      if (this.focusedIndex < this.multiListData.length - 1) {
        this.focusedIndex++;
        this.scrollFocusedItemIntoView();
      } else if (!isFiltered && !this.isLoadingMore) {
        this.isLoadingMore = true;
        this.loadMore.emit();
        setTimeout(() => {
          this.scrollDropdownToBottom();
          this.focusedIndex++;
          this.scrollFocusedItemIntoView();
          this.isLoadingMore = false;
        }, 300);
      }
      event.preventDefault();
    } else if (event.key === 'ArrowUp') {
      if (this.focusedIndex > 0) {
        this.focusedIndex--;
        this.scrollFocusedItemIntoView();
      } else if (!isFiltered && !this.isLoadingPrevious) {
        this.isLoadingPrevious = true;
        this.loadMore.emit();
        setTimeout(() => {
          this.scrollDropdownToTop();
          this.focusedIndex = 0;
          this.scrollFocusedItemIntoView();
          this.isLoadingPrevious = false;
        }, 300);
      }
      event.preventDefault();
    } else if (event.key === 'Enter') {
      if (this.focusedIndex >= 0 && this.focusedIndex < this.multiListData.length) {
        this.singleSelectedValue(this.multiListData[this.focusedIndex]);
        this.focusedIndex = -1;
      }
      event.preventDefault();
    }
  }

  scrollDropdownToBottom() {
    const el = this.dropdownContainer?.nativeElement;
    if (el) {
      el.scrollTop = el.scrollHeight;
    }
  }

  scrollDropdownToTop() {
    const el = this.dropdownContainer?.nativeElement;
    if (el) {
      el.scrollTop = 0;
    }
  }

  scrollFocusedItemIntoView() {
    const container = this.dropdownContainer?.nativeElement;
    if (container) {
      const labels = container.querySelectorAll('label');
      if (labels[this.focusedIndex]) {
        (labels[this.focusedIndex] as HTMLElement).scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      }
    }
  }

  onDropdownFocusIn() {
    clearTimeout(this.dropdownFocusTimeout);
  }

  onDropdownFocusOut() {
    this.dropdownFocusTimeout = setTimeout(() => {
      this.showDropDown = false;
      this.blur.emit();
    }, 200);
  }

  clearSelection(event: any) {
    this.previousSeletedValues = null;
    this.selectedIDs = [];
    this.checkedList = [];
    this.multiSelectedIDs = [];
    this.checkedMultiList = [];
    this.selectedSubItems = {};
    this.listData = this.listData?.map(item => ({ ...item, checked: false }));
    this.multiListData = this.listData;
    this.selectedValues.emit(null);
  }

  getPreviousSelectedValue() {
    if (!this.previousSeletedValues || !this.listData) return;
    const list = Array.isArray(this.listData) ? this.listData : [];
    const normalizeId = (v: any) => {
      if (v == null) return null;
      if (typeof v === 'object') return v._id ?? v.id ?? v;
      return v;
    };
    const prev = this.previousSeletedValues;
    const prevId = normalizeId(prev);
    if (!prevId) return;
    const existsIndex = list.findIndex((item: any) => (item._id ?? item.id ?? item.name) === prevId || item.name === prevId);
    if (existsIndex > -1) {
      const [item] = list.splice(existsIndex, 1);
      item.checked = true;
      list.unshift(item);
    }
    for (let i = 1; i < list.length; i++) {
      list[i] = { ...list[i], checked: false };
    }
    const seen = new Set();
    const deduped: any[] = [];
    for (const it of list) {
      const key = it._id ?? it.id ?? it.name;
      if (!seen.has(key)) {
        seen.add(key);
        deduped.push(it);
      }
    }
    this.listData = deduped;
    this.multiListData = deduped;
  }

  onItemMouseEnter(item: any, index: number) {
    if (this.submenuHoverTimeout) {
      clearTimeout(this.submenuHoverTimeout);
      this.submenuHoverTimeout = null;
    }
    this.hoveredItem = item;
    this.hoveredIndex = index;
  }

  onItemMouseLeave() {
    this.submenuHoverTimeout = setTimeout(() => {
      this.hoveredItem = null;
      this.hoveredIndex = -1;
    }, 200);
  }

  onSubmenuMouseEnter() {
    if (this.submenuHoverTimeout) {
      clearTimeout(this.submenuHoverTimeout);
      this.submenuHoverTimeout = null;
    }
  }

  isSubItemChecked(parentItem: any, subItem: string): boolean {
    return this.multiSelectedIDs.includes(subItem);
  }

}
